import styled from "@emotion/styled/macro";
import Box from "@mui/material/Box";
import isStyledPropsValid from "utils/isStyledPropsValid";

export const StyledUserTag = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, bgColor, textColor }) => ({
  backgroundColor: bgColor,
  width: "fit-content",
  padding: "2px 4px",
  borderRadius: "2px",
  color: textColor,
  fontSize: "10px",
  fontWeight: 500,
}));

export const StyledTooltipRow = styled("div", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  columnGap: 8,
  color: theme.customColors.grey[700],
  fontSize: "12px",
}));

export const StyledDot = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  width: "4px",
  height: "4px",
  borderRadius: "50%",
  background: "#000",
}));
